import React from "react";
import About1 from "../Assets/about.png";
import OurApproach from "../Assets/ourApproach.png";
import Logo1 from "../Assets/partner.png";
import Logo2 from "../Assets/established.jpg";
import Logo3 from "../Assets/strength.png";
import Logo4 from "../Assets/focus.jpg";

function About() {
 const highlights = [
  {
    title: "Established Legacy",
    image: Logo2,
    description:
      "Electromates Robotics & Automation (India) Pvt. Ltd. was established in 1992 and brings over three decades of engineering experience.",
  },
  {
    title: "Engineering Focus",
    image: Logo4,
    description:
      "The company specializes in industrial automation, energy-efficient technologies and sustainable infrastructure solutions.",
  },
  {
    title: "Execution Strength",
    image: Logo3,
    description:
      "With strong engineering fundamentals, solution-centric design and disciplined execution, Electromates helps industries solve complex operational challenges.",
  },
  {
    title: "Trusted Partnerships",
    image: Logo1,
    description:
      "Electromates works with globally recognized technology leaders to deliver advanced automation and sustainability-driven solutions.",
  },
];

  const values = [
    "Solution-centric engineering",
    "Operational excellence",
    "Reliability and productivity",
    "Sustainability-driven innovation",
    "Disciplined project execution",
    "Long-term customer partnership",
  ];

  return (
    <div style={{ backgroundColor: "#f7fbff", overflowX: "hidden" }}>
      {/* HERO SECTION */}
     <section
  style={{
    background:
      "linear-gradient(135deg, #edf7ff 0%, #d8ecfb 45%, #f7fbff 100%)",
    padding: "90px 0 70px 0",
    position: "relative",
    overflow: "hidden",
  }}
>
  <div
    style={{
      position: "absolute",
      top: "30px",
      left: "-70px",
      width: "220px",
      height: "220px",
      borderRadius: "50%",
      background: "rgba(29,169,232,0.10)",
      filter: "blur(10px)",
      animation: "floatY 5s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    className="container"
    style={{
      position: "relative",
      zIndex: 2,
    }}
  >
    <div className="row align-items-center gy-5">
      <div className="col-lg-6">
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#e6f4ff",
            color: "#0B5CAD",
            padding: "10px 18px",
            borderRadius: "30px",
            fontWeight: 700,
            fontSize: "14px",
            marginBottom: "18px",
            animation: "fadeUp 1s ease",
          }}
        >
          ABOUT ELECTROMATES
        </div>

        <h1
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            fontSize: "clamp(2.2rem, 5vw, 3.7rem)",
            lineHeight: "1.15",
            marginBottom: "18px",
            animation: "fadeUp 1.1s ease",
          }}
        >
          Engineering Progress Through
          <br />
          Automation & Sustainability
        </h1>

        <p
          style={{
            color: "#4a5568",
            fontSize: "17px",
            lineHeight: "1.9",
            marginBottom: "24px",
            animation: "fadeUp 1.2s ease",
          }}
        >
          Electromates Robotics & Automation (India) Pvt. Ltd. is a
          professionally managed engineering solutions company focused on
          industrial automation, energy efficiency and sustainable
          infrastructure development.
        </p>

        <div className="row g-3">
          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                1992
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Established
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                30+
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Years Experience
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Multi
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Industry Solutions
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            background: "linear-gradient(135deg, #ffffff 0%, #eef7ff 100%)",
            borderRadius: "28px",
            boxShadow: "0 18px 45px rgba(11,92,173,0.12)",
            border: "1px solid rgba(11,92,173,0.08)",
            position: "relative",
            overflow: "hidden",
            animation: "zoomInSoft 1.2s ease",
            aspectRatio: "16 / 10",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: "0",
              background: "rgba(11,92,173,0.04)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          ></div>

          <img
            src={About1}
            alt="About Electromates"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

      {/* COMPANY OVERVIEW */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row gy-4 align-items-center">
            <div className="col-lg-7">
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "24px",
                  padding: "34px",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.05)",
                  borderLeft: "6px solid #1DA9E8",
                }}
              >
                <h2
                  style={{
                    color: "#0B5CAD",
                    fontWeight: 800,
                    marginBottom: "18px",
                  }}
                >
                  Who We Are
                </h2>

                <p style={{ color: "#4a5568", lineHeight: "1.95" }}>
                  Electromates partners with industries to improve operational
                  excellence, reliability, productivity and environmental
                  performance through advanced engineering solutions. The
                  company combines industrial automation expertise with
                  sustainability-focused technologies to support smarter and
                  more efficient operations. 
                </p>

                <p
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.95",
                    marginBottom: 0,
                  }}
                >
                  By working with globally recognized technology leaders,
                  Electromates has delivered several first-of-the-kind
                  automation and sustainability solutions across manufacturing,
                  utilities, infrastructure and commercial sectors.
                </p>
              </div>
            </div>

            <div className="col-lg-5">
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #eaf6ff 0%, #ffffff 100%)",
                  borderRadius: "24px",
                  padding: "28px",
                  border: "2px dashed #9ad3f5",
                  minHeight: "100%",
                }}
              >
                <h4
                  style={{
                    color: "#0B5CAD",
                    fontWeight: 700,
                    marginBottom: "16px",
                  }}
                >
                  What We Help Customers Achieve
                </h4>

                <ul style={{ paddingLeft: "18px", marginBottom: 0 }}>
                  <li style={{ color: "#4a5568", lineHeight: "1.9" }}>
                    Higher operational excellence
                  </li>
                  <li style={{ color: "#4a5568", lineHeight: "1.9" }}>
                    Better reliability and uptime
                  </li>
                  <li style={{ color: "#4a5568", lineHeight: "1.9" }}>
                    Improved productivity
                  </li>
                  <li style={{ color: "#4a5568", lineHeight: "1.9" }}>
                    Smarter energy use
                  </li>
                  <li style={{ color: "#4a5568", lineHeight: "1.9" }}>
                    Sustainable infrastructure adoption
                  </li>
                  <li style={{ color: "#4a5568", lineHeight: "1.9" }}>
                    Confidence in solving complex industrial challenges
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HIGHLIGHTS */}
  <section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
  }}
>
  <div className="container py-4">
    <div className="text-center mb-5">
      <h2
        style={{
          color: "#0B5CAD",
          fontWeight: 800,
          marginBottom: "12px",
        }}
      >
        What Defines Electromates
      </h2>
      <p
        style={{
          maxWidth: "780px",
          margin: "0 auto",
          color: "#5b6777",
          lineHeight: "1.8",
        }}
      >
        A balanced combination of legacy, engineering strength,
        technology-backed execution and sustainability-driven thinking.
      </p>
    </div>

    <div className="row g-4">
  {highlights.map((item, index) => (
    <div className="col-md-6 col-lg-3" key={index}>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "22px",
          padding: "26px",
          height: "100%",
          boxShadow: "0 14px 34px rgba(11,92,173,0.08)",
          transition: "0.3s",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            marginBottom: "14px",
          }}
        >
          <div
            style={{
              width: "58px",
              height: "58px",
              minWidth: "58px",
              borderRadius: "16px",
              backgroundColor: "#e6f4ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              padding: 0,
            }}
          >
            <img
              src={item.image}
              alt={item.title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>

          <h5
            style={{
              color: "#0B5CAD",
              fontWeight: 700,
              marginBottom: 0,
              lineHeight: "1.4",
            }}
          >
            {item.title}
          </h5>
        </div>

        <p
          style={{
            color: "#4a5568",
            lineHeight: "1.8",
            marginBottom: 0,
            fontSize: "15px",
          }}
        >
          {item.description}
        </p>
      </div>
    </div>
  ))}
</div>
  </div>
</section>

      {/* VALUES + IMAGE PLACEHOLDER */}
<section className="py-5">
  <div className="container py-4">
    <div className="row align-items-center gy-4">
      <div className="col-lg-7 order-1 order-lg-2">
        <h2
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            marginBottom: "18px",
          }}
        >
          Our Approach
        </h2>

        <p
          style={{
            color: "#4a5568",
            lineHeight: "1.9",
            marginBottom: "20px",
          }}
        >
          Electromates combines strong engineering fundamentals,
          solution-centric design and disciplined execution to help
          customers transition toward smart, efficient and sustainable
          operations.
        </p>

        <div className="row g-3">
          {values.map((value, index) => (
            <div className="col-sm-6" key={index}>
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "16px 18px",
                  boxShadow: "0 8px 20px rgba(11,92,173,0.06)",
                  color: "#2d3748",
                  fontWeight: 600,
                  height: "100%",
                  borderLeft: "4px solid #0B5CAD",
                }}
              >
                {value}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="col-lg-5 order-2 order-lg-1">
        <div
          style={{
            width: "100%",
            background: "linear-gradient(135deg, #ffffff 0%, #eef7ff 100%)",
            borderRadius: "24px",
            boxShadow: "0 18px 40px rgba(11,92,173,0.12)",
            border: "1px solid rgba(11,92,173,0.08)",
            overflow: "hidden",
            position: "relative",
            padding: "10px",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "18px",
              right: "18px",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              background: "rgba(29,169,232,0.18)",
              filter: "blur(22px)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          ></div>

          <div
            style={{
              width: "100%",
              position: "relative",
              zIndex: 2,
              borderRadius: "18px",
              overflow: "hidden",
              aspectRatio: "16 / 11",
            }}
          >
            <img
              src={OurApproach}
              alt="Our Approach"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* CTA */}
      <section className="py-5">
        <div className="container py-4">
          <div
            style={{
              background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
              borderRadius: "28px",
              padding: "50px 30px",
              textAlign: "center",
              color: "#ffffff",
              boxShadow: "0 16px 40px rgba(11,92,173,0.20)",
            }}
          >
            <h2 style={{ fontWeight: 800, marginBottom: "14px" }}>
              Let’s Build Efficient, Reliable and Sustainable Systems
            </h2>
            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto 24px",
                lineHeight: "1.85",
                color: "rgba(255,255,255,0.92)",
              }}
            >
              Electromates brings decades of engineering insight to industries
              seeking better automation, smarter energy use and future-ready
              infrastructure solutions.
            </p>

            <a
              href="/contact"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#0B5CAD",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "none",
              }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;